import "./css/app.scss";
import "./bootstrap"; 
import 'cropperjs/dist/cropper.css';

// Import Vendor Libraries
import * as bootstrap from "bootstrap";
window.bootstrap = bootstrap; 
import jQuery from "jquery";
import QrScanner from "qr-scanner";
import QrCreator from "qr-creator";
import DOMPurify from "dompurify";
import Swal from "sweetalert2";

// Expose to window for legacy support
window.$ = window.jQuery = jQuery;
window.QrScanner = QrScanner;
window.QrCreator = QrCreator; 
window.DOMPurify = DOMPurify;
window.Swal = Swal;

import "./index";
